import { Paper, Stack } from "@flpstudio/design-system";

import { PublishedDocumentPreview } from "@/components/organisms/Document/PublishedDocumentPreview";
import { BestPracticeDocumentRenderer } from "@/components/organisms/Document/renderer/BestPracticeDocumentRenderer";
import {
  sendLinkPreviewClickEvent,
  sendSoftwareRecommendationClickEvent,
} from "@/components/organisms/Document/utils";
import { useAuth } from "@/hooks/use-auth";
import type { BestPracticeDocument } from "types";
import { DocumentMeta } from "./DocumentMeta";

type Props = {
  document: BestPracticeDocument;
};

export function BestPracticeDocumentViewer({ document }: Props) {
  const { user } = useAuth();
  if (document.relatedTopicDocuments?.length) {
    return (
      <Stack>
        {[document, ...document.relatedTopicDocuments].map((doc) => (
          <Paper key={doc.id} className="-mx-6 lg:mx-0">
            <PublishedDocumentPreview document={doc} />
          </Paper>
        ))}
      </Stack>
    );
  }

  return (
    <Paper className="-mx-6 lg:mx-0">
      <Stack component="article">
        <DocumentMeta document={document} />
        {document.content?.prompts.map((content) => (
          <BestPracticeDocumentRenderer
            key={content.id}
            content={content}
            currentTitleOrder={1}
            onLinkPreviewClick={(url) =>
              sendLinkPreviewClickEvent({
                document,
                user,
                url,
              })
            }
            onSoftwareRecommendationClick={(software) =>
              sendSoftwareRecommendationClickEvent({
                document,
                user,
                software,
              })
            }
          />
        ))}
      </Stack>
    </Paper>
  );
}
